<template>
  <div>
    <Header @clickedNavBarIcon="onClickedNavBarIcon"/>
    <Sidebar @updatedMiniVariant="onClickedNavBarIcon" :mini="miniSidebar" :items="items"/>
    <v-main>
      <Breadcrumb/>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <Footer/>
    <Snackbar ref="messages"/>
    <Loader ref="loader"/>
  </div>
</template>
<script>
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import Breadcrumb from "./components/Breadcrumb";
import nav from "~/router/routes";
import Loader from "~/views/layouts/components/Loader";
import Snackbar from "~/views/layouts/components/Snackbar";

export default {
  name: 'Default',
  components: {Snackbar, Loader, Breadcrumb, Footer, Sidebar, Header},
  data: () => ({
    miniSidebar: true,
    items: nav.find(menu => menu.path = '/' && menu.children).children
  }),
  methods: {
    onClickedNavBarIcon(value) {
      if (value === undefined) {
        this.miniSidebar = !this.miniSidebar;
      } else {
        this.miniSidebar = value;
      }
    },
    loadCurrentUser() {
      return this.$store.dispatch('auth/me');
    }
  },
  mounted() {
    this.loadCurrentUser();
    this.$root.$loader = this.$refs.loader;
    this.$root.$messages = this.$refs.messages;
  }
}
</script>